import { cloneDeep, last, uniqBy } from 'lodash-es'

export const listToTree = (list = [], key = 'id') => {
  const obj = {}
  const treeData = []
  list
    .sort((a, b) => {
      return a.level - b.level
    })
    .forEach((item) => {
      obj[item[key]] = {
        ...item,
        parentsName: [item.title],
        parentsId: [item[key]],
        parents: [item],
        children: [],
        parentsIdStr: item[key],
      }
    })

  Object.values(obj).forEach((item) => {
    if (item.parentId && obj[item.parentId]) {
      if (!obj[item.parentId].children) {
        obj[item.parentId].children = []
      }
      // 记录一下所有父级的title、id
      item.parentsName = obj[item.parentId].parentsName.concat(item.parentsName)
      item.parents = obj[item.parentId].parents.concat(item)
      item.parentsId = obj[item.parentId].parentsId.concat(item.parentsId)
      item.parentsIdStr = item.parentsId.join('-')
      item.parentsNameStr = item.parentsName.join('-')
      // .concat([obj[item.parentId].id])
      obj[item.parentId].children.push(item)
    } else {
      // item.parentsIdStr = item.parentsId.join('-')
      item.parentsNameStr = item.parentsName.join('-')
      treeData.push(item)
    }
  })

  return treeData
}

export const listToTable = (list) => {
  const tree = listToTree(list)
  let arr = []
  let parent = []
  const tableData = []
  const iterTree = (layer) => {
    layer.forEach((l) => {
      if (l.level === 1) {
        parent = []
        parent.push(l)
      }
      if (l.children && l.children.length > 0) {
        if (l.level !== 1) {
          arr.push(l)
        }
        iterTree(l.children)
      } else {
        tableData.push(uniqBy([...parent, ...arr, l], 'objectId'))
      }
    })
    arr = []
  }
  iterTree(tree)
  return tableData
}

export const listToTableWithCount = (list, tree, countMap) => {
  const tableData = listToTable(list, tree)
  const dataMapWithParent = {}
  tableData.forEach((line) => {
    const count = countMap[last(line).objectId] || 0
    line.forEach((item) => {
      if (!dataMapWithParent[item.objectId]) {
        dataMapWithParent[item.objectId] = 0
      }
      dataMapWithParent[item.objectId] += count
    })
  })
  return dataMapWithParent
}

export const filterTree = (tree, valueAry) => {
  const _tree = cloneDeep(tree)
  return _tree.filter(function iter(node) {
    let temp = []
    if (node.title && node.title.indexOf(valueAry) !== -1) {
      return true
    }
    if (!Array.isArray(node.children) || node.children.length === 0) {
      return false
    }
    temp = node.children.filter(iter)
    if (temp.length) {
      node.children = temp
      return true
    }
    return false
  })
}

export const filterLeaf = (tree, limit = []) => {
  if (!limit.length) return tree

  const _tree = cloneDeep(tree)

  return _tree.filter(function iter(node) {
    if (!Array.isArray(node.children) || !node.children.length) {
      return limit.includes(node.id)
    }

    node.children = node.children.filter(iter)

    return node.children.length > 0
  })
}

// 查询树节点
export const queryNode = (tree, nodeId) => {
  let selectNode = null
  tree.find((node) => {
    if (node.id === nodeId) {
      selectNode = node
      return true
    }
    if (node.children && node.children.length > 0) {
      const temp = queryNode(node.children, nodeId)
      if (temp && temp.id === nodeId) {
        selectNode = temp
        return true
      }
      return false
    }
    return false
  })
  return selectNode
}
